/**
 * Basiq Service Layer
 * Connects directly to your local Spring Boot API gateway.
 */

import { baseUrl_SPB } from "../../../../../BaseUrl";

// If your backend runs on a different port or base path (e.g., http://localhost:8080/api), 
// set it here. Leave empty if your React app is proxied or shares the same domain.
const API_BASE_URL = ''; 

/**
 * Communicates with your Spring Boot controller:
 * @GetMapping("/gettransactions")
 * * @param {string} authToken - Your internal JWT application token for security (if applicable)
 * @param {string} basiqUserId - The Basiq user identifier requested by the controller
 * @returns {Promise<Array>} A promise that resolves to the array of bank transactions
 */
export const fetchBasiqTransactions = async (authToken, basiqUserId,companyId) => {
  try {
    // Construct the URL matching your @RequestParam String basiqUserId
    const url = `${baseUrl_SPB}/api/v1/basiq/gettransactions?basiqUserId=${encodeURIComponent(basiqUserId)}&companyId=${encodeURIComponent(companyId)}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${authToken}`, // Included if your backend enforces JWT verification
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Spring Boot backend responded with status: ${response.status}`);
    }

    const jsonResponse = await response.json();

    // Handle both cases: if your Spring Boot wrapper returns the raw Basiq object 
    // containing a "data" array, or if it unpacks it and returns the array directly.
    if (jsonResponse && jsonResponse.data) {
      return jsonResponse.data; 
    }
    
    return Array.isArray(jsonResponse) ? jsonResponse : [];

  } catch (error) {
    console.error('Error in fetchBasiqTransactions service:', error);
    throw error; // Let the calling component catch and handle the loading state safely
  }
};